export default "__VITE_ASSET__Bs2B7bq7__"